var map = {
	"./default/about-us/en.md": [
		"9ea9",
		"chunk-2d0f113a"
	],
	"./default/about-us/sl.md": [
		"ad0c",
		"chunk-2d21368c"
	],
	"./default/cookies/en.md": [
		"a872",
		"chunk-2d209208"
	],
	"./default/cookies/sl.md": [
		"b54d",
		"chunk-2d20faf9"
	],
	"./default/declaration-conformity/en.md": [
		"e84e",
		"chunk-2d22635a"
	],
	"./default/declaration-conformity/sl.md": [
		"62a0",
		"chunk-2d0cf4a1"
	],
	"./default/privacy-policy/en.md": [
		"f01e",
		"chunk-2d22b954"
	],
	"./default/privacy-policy/sl.md": [
		"e851",
		"chunk-2d226345"
	],
	"./default/support/en.md": [
		"f708",
		"chunk-2d22d34f"
	],
	"./default/support/sl.md": [
		"bce5",
		"chunk-2d21ad67"
	],
	"./default/terms/en.md": [
		"1312",
		"chunk-2d0aacb9"
	],
	"./default/terms/sl.md": [
		"4b06",
		"chunk-2d0cba2a"
	],
	"./kranj/about-us/en.md": [
		"bc97",
		"chunk-2d21a815"
	],
	"./kranj/about-us/sl.md": [
		"311f",
		"chunk-2d0b8e29"
	],
	"./kranj/cookies/en.md": [
		"bffb",
		"chunk-2d21b8f6"
	],
	"./kranj/cookies/sl.md": [
		"beaa",
		"chunk-2d21b499"
	],
	"./kranj/declaration-conformity/en.md": [
		"9c9b",
		"chunk-2d0f0509"
	],
	"./kranj/declaration-conformity/sl.md": [
		"8ed5",
		"chunk-2d0e9d34"
	],
	"./kranj/privacy-policy/en.md": [
		"6ccf",
		"chunk-2d0dad06"
	],
	"./kranj/privacy-policy/sl.md": [
		"0202",
		"chunk-2d0a347a"
	],
	"./kranj/support/en.md": [
		"4643",
		"chunk-2d0c1577"
	],
	"./kranj/support/sl.md": [
		"46ba",
		"chunk-2d0c1b37"
	],
	"./kranj/terms/en.md": [
		"9c24",
		"chunk-2d0f0402"
	],
	"./kranj/terms/sl.md": [
		"bd72",
		"chunk-2d21ab93"
	],
	"./logatec/about-us/en.md": [
		"8ebc",
		"chunk-2d0e9d24"
	],
	"./logatec/about-us/sl.md": [
		"a01d",
		"chunk-2d207378"
	],
	"./logatec/cookies/en.md": [
		"7efd",
		"chunk-2d0e2942"
	],
	"./logatec/cookies/sl.md": [
		"ee2b",
		"chunk-2d230c06"
	],
	"./logatec/declaration-conformity/en.md": [
		"adc9",
		"chunk-2d213c8f"
	],
	"./logatec/declaration-conformity/sl.md": [
		"2a8b",
		"chunk-2d0bcecf"
	],
	"./logatec/privacy-policy/en.md": [
		"f459",
		"chunk-2d22c8a8"
	],
	"./logatec/privacy-policy/sl.md": [
		"7228",
		"chunk-2d0d6357"
	],
	"./logatec/support/en.md": [
		"5c0b",
		"chunk-2d0d3276"
	],
	"./logatec/support/sl.md": [
		"3465",
		"chunk-2d0b99d6"
	],
	"./logatec/terms/en.md": [
		"6dbc",
		"chunk-2d0db0a5"
	],
	"./logatec/terms/sl.md": [
		"f7df",
		"chunk-2d22d9c9"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0e38";
module.exports = webpackAsyncContext;